import { Alert, Box } from '@mui/material';
import React from 'react';
import { useCommonFormUiTranslation } from '../hooks';
import { loadScript } from '../utils/loadScript';
/**
 * This Component loads Altcha CDN modules https://cdnjs.juvare.com/ajax/libs/altcha/1.1.0/altcha.min.js
 * Waits for scripts to be loaded and then renders children.
 *
 * @param {AltchaCdnProps} root0 - Component props.
 * @param {React.ReactNode} root0.loadingFallback - A fallback UI to display while the script is loading.
 * @param {React.ReactElement} root0.children - The children elements to render after the script has loaded.
 * @returns {React.ReactElement} The rendered children or a fallback/error element.
 */
export const AltchaCdn = ({ loadingFallback, children }) => {
    const [loaded, setLoaded] = React.useState(false);
    const [error, setError] = React.useState(false);
    const { t } = useCommonFormUiTranslation();
    React.useEffect(() => {
        const scriptUrl = 'https://cdnjs.juvare.com/ajax/libs/altcha/1.1.0/altcha.min.js';
        loadScript(scriptUrl, { type: 'module' })
            .then(() => setLoaded(true))
            .catch(() => setError(true));
    }, []);
    if (loaded) {
        return children;
    }
    else if (error) {
        return React.createElement(Alert, { severity: 'error' }, t('altcha.error'));
    }
    else {
        return loadingFallback !== null && loadingFallback !== void 0 ? loadingFallback : React.createElement(Box, null, t('common.loading'));
    }
};
